import React, { Component } from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

import Logger, { LOG_LEVELS } from '../../utils/logger';
const log = new Logger('ACTIONS_MENU', LOG_LEVELS.DEBUG);

export class ActionsMenu extends Component {

  render() {
    log.debug('render(): ', this.props);
    return (
        <span data-test="component-actions-menu">
            <ReadOnlyWrapper>
                <ul>
                    {this.props.onHoldData.financialDataOnHoldFrom ? (
                        <li data-test="actions-menu-unlock-financial"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.UNLOCK_FINANCIAL, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_UnlockFinancialData'/></a></li>
                    ):( <li data-test="actions-menu-lock-financial"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.LOCK_FINANCIAL, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_LockFinancialData'/></a></li> )}

                    {this.props.onHoldData.logisticalDataOnHoldFrom ? (
                        <li data-test="actions-menu-unlock-logistical"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.UNLOCK_LOGISTICAL, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_UnlockLogisticalData'/></a></li>
                    ):( <li data-test="actions-menu-lock-logistical"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.LOCK_LOGISTICAL, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_LockLogisticalData'/></a></li> )}

                    {this.props.onHoldData.financialDataOnHoldFrom && this.props.onHoldData.logisticalDataOnHoldFrom ? (
                        <li data-test="actions-menu-unlock-both"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.UNLOCK_BOTH, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_UnlockBoth'/></a></li>
                    ):( "" )}

                    {this.props.onHoldData.financialDataOnHoldFrom === "" && this.props.onHoldData.logisticalDataOnHoldFrom === "" ? (
                        <li data-test="actions-menu-lock-both"><a className="tertiary" onClick={this.props.openModal.bind(this, this.props.actions.LOCK_BOTH, this.props.modalCountryData)}><LanguageStringResolver string='countriesOnHold_LockBoth'/></a></li>
                    ):( "" )}
                </ul>
            </ReadOnlyWrapper>
        </span>
        );
    }
}

ActionsMenu.defaultProps = {
    openModal: false,
    modalCountryData: "",
    onHoldData: "",
  };

export default (ActionsMenu);